import { render } from "./SortByPopover.vue?vue&type=template&id=0daa027a&scoped=true&ts=true"
import script from "./SortByPopover.vue?vue&type=script&lang=ts"
export * from "./SortByPopover.vue?vue&type=script&lang=ts"

import "./SortByPopover.vue?vue&type=style&index=0&id=0daa027a&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0daa027a"]])

export default __exports__